<div class="coach-response-dialog">
    <div class="dialog-header">
        <div class="header-content">
            <img src="../../../../assets/icons/coach-assist.svg" alt="Coach" class="coach-icon" />
            <span class="title">Coach Response</span>
        </div>
        <button class="close-btn" (click)="close()">
            <img src="../../../assets/icons/icon-close.png" alt="Close" />
        </button>
    </div>
    <div class="dialog-body">
        <div class="timestamp">
            <span>Generated at {{data.timestamp}}</span>
        </div>
        <div class="response-content">
            <markdown class="variable-binding" [data]="data.coachResponse"></markdown>
        </div>
        <div class="references-section" *ngIf="data.references?.length">
            <span class="references-title">References</span>
            <ul class="references-list">
                <li *ngFor="let ref of data.references">
                    <a class="ref-filename" (click)="openReference(ref, $event)" href="javascript:void(0)">{{ ref.FileName }}</a>
                    <span class="ref-page" *ngIf="ref.page_number"> — Page {{ ref.page_number }}</span>
                </li>
            </ul>
        </div>
    </div>
    <div class="dialog-footer">
        <button class="btn-close" (click)="close()">Close</button>
    </div>
</div>
